import { Injectable } from '@angular/core';
import { AutoDiscountModel } from './model/autodiscount.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AutoDiscountService {

  constructor(private http: HttpClient) { }
  /**
     * Fetches the list of auto discounts based on provided filters.
     * @param requestData Filters or pagination data.
     * @returns Observable of the auto discount list.
     */
  getAutoDiscountList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/auto-discount/get', requestData);

  }
  /**
    * Fetches auto discount data by ID.
    * @param id Unique ID of the auto discount.
    * @returns Observable of the specific auto discount data.
    */
  getAutoDiscountById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/auto-discount/get/' + id, '');
  }

  /**
  * Adds a new auto discount or updates an existing one.
  * @param discountInfo The auto discount model containing form data.
  * @returns Observable of the API response after save/update.
  */
  update(discountInfo: AutoDiscountModel): Observable<any> {
    if (discountInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/auto-discount/update', discountInfo);
    } else {
      return this.http.post(environment.baseUrl + '/auto-discount/add', discountInfo);
    }
  }
  /**
    * Retrieves master data required for setting up auto discounts,
    * including main groups, subgroups, and sale items.
    * @returns Observable containing master data.
    */
  getMasterData(): Observable<any> {
    return this.http.post(environment.baseUrl + '/auto-discount/get-master', "");
  }

  /**
     * Deletes a specific auto discount record.
     * @param discountInfo The auto discount model to be deleted.
     * @returns Observable of the delete operation response.
     */
  delete(discountInfo: AutoDiscountModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/auto-discount/delete/' + discountInfo.id, discountInfo);
  }
  /**
    * Exports the auto discount list as an Excel file.
    * @param requestData Filters or parameters for export.
    * @returns Observable of Blob (Excel file).
    */
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(environment.baseUrl + '/auto-discount/export-auto-discount-list', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );

  }

}
